import { notification } from 'antd';
import { list, create, update, remove, _batchCreate, _batchDelete } from '@/services/firestore';

  const namespace = 'plannedDowntimes';
  export default {
    namespace,
  
    state: {
      loadingList: false,
      loadingUpdate: false,
      loadingCreate: false,
      loadingRemove: false,
      plannedStoppages: [],
      list: [],
      current: null
    },
  
    effects: {
      *list({ payload }, { call, put, takeEvery, take, select }) {
        // clear old before new request
        yield put({
          type: `clear:${namespace}/list`,
        });
  
        yield put({
          type: 'save',
          payload: { loadingList: true },
        });

        // create subscription
        const service = yield call(list, {
          module: namespace,
          // orderBy: ['from', 'asc'],
          ...payload,
        });
  
        function* push(response) {
          let list = null
          if (response.operationType)
          {
            response.id = response['_id']
            list = yield select(state => state.plannedDowntimes.list);
            list = JSON.parse(JSON.stringify(list))
            list = list.concat(JSON.parse(JSON.stringify(yield select(state => state.plannedDowntimes.plannedStoppages))))
     
            let index = list.findIndex(x => x.id == response.id)
            if (index > -1)
            {
              if (response.operationType == 'delete')
                list.splice(index, 1);
              else
              {
                delete response['operationType']
                list[index] = response
              }
            }
            else if (response['operationType'] != 'delete') {
              delete response['operationType']
              list.push(response)
            }
          }
          else
            list = Array.isArray(response)  ? response : [];

          let downtimes = list.
          filter(x => x.from).sort((a, b) =>  a.from.localeCompare(b.from))
          let stoppages = list.
          filter(x => x.maxMinutes).sort((a,b) => a.maxMinutes - b.maxMinutes)

          yield put({
            type: 'saveList',
            payload: {downtimes, stoppages}
          });
        }
  
        // on every callback from service
        yield takeEvery(service, push);
  
        // unsubscribe & clear when this action fired
        yield take(`clear:${namespace}/list`);
        service.close();
        yield put({
          type: 'clearList',
        });
      },
  
      *create({ payload }, { call, put }) {
        yield put({
          type: 'save',
          payload: { loadingCreate: true },
        });
  
        try {
          const response = yield call(create, {
            module: namespace,
            ...payload,
          });
          if (response) {
            notification.success({
              message: 'Planned downtime added',
            });


            yield put({
              type: 'save',
              payload: { current: response },
            });
          }
          yield put({
            type: 'save',
            payload: { loadingCreate: false },
          });
        } catch (error) {
          notification.error({
            message: error.message,
          });
  
          yield put({
            type: 'save',
            payload: { loadingCreate: false },
          });
        }
      },
      *batchCreate({ payload }, { call, put }) {
        yield put({
          type: 'save',
          payload: { loadingCreate: true },
        });
  
        try {
          const response = yield call(batchCreate, {
            module: namespace,
            ...payload,
          });
          if (response) {
            notification.success({
              message: 'Planned Downtimes added',
            });
          }
          yield put({
            type: 'save',
            payload: { loadingCreate: false },
          });
        } catch (error) {
          // console.log("error", error);
          notification.error({
            message: error.message,
          });
  
          yield put({
            type: 'save',
            payload: { loadingCreate: false },
          });
        }
      },
      *batchDelete({ payload }, { call, put }) {
        yield put({
          type: 'save',
          payload: { loadingRemove: true },
        });
  
        try {
          const response = yield call(batchDelete, {
            module: namespace,
            ...payload,
          });
          if (response) {
            notification.success({
              message: 'Planned downtimes deleted',
            });
          }
          yield put({
            type: 'save',
            payload: { loadingRemove: false },
          });
        } catch (error) {
          // console.log("error", error);
          notification.error({
            message: error.message,
          });
  
          yield put({
            type: 'save',
            payload: { loadingRemove: false },
          });
        }
      },
      *update({ payload }, { call, put }) {
        try {
          yield put({
            type: 'save',
            payload: { loadingUpdate: true },
          });
          const response = yield call(update, {
            module: namespace,
            ...payload,
          });
          if (response) {
            notification.success({
              message: 'Planned downtime updated',
            });
          }
          yield put({
            type: 'save',
            payload: { loadingUpdate: false },
          });
        } catch (error) {
          console.error('update error', error);
          notification.error({
            message: error.message,
          });
          yield put({
            type: 'save',
            payload: { loadingUpdate: false },
          });
        }
      },
  
      *remove({ payload }, { call, put }) {
        yield put({
          type: 'save',
          payload: { loadingRemove: true },
        });
  
        try {
          const response = yield call(remove, {
            module: namespace,
            ...payload,
          });
          if (response) {
            notification.success({
              message: 'Planned downtime deleted',
            });
          }
          yield put({
            type: 'save',
            payload: { loadingRemove: false },
          });
        } catch (error) {
          notification.error({
            message: error.message,
          });
  
          yield put({
            type: 'save',
            payload: { loadingRemove: false },
          });
        }
      },
      *unsubscribe(_, { put }) {
        yield put({ type: `clear:${namespace}/list` });
      },
    },
  
    reducers: {
      save(state, { payload }) {
        return {
          ...state,
          ...payload,
        };
      },
      saveList(state, { payload }) {
        return {
          ...state,
          list: payload.downtimes,
          plannedStoppages: payload.stoppages,
          loadingList: false,
        };
      },
      clearList(state) {
        return {
          ...state,
          list: [],
          plannedStoppages: [],
          loadingList: false,
        };
      },
    },
  };